import { Quote } from "lucide-react";
import { TESTIMONIALS } from "../../data";
import { SectionHeading, Reveal } from "./Shared";

export const Testimonials = () => {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative py-28 px-6 bg-[#151c0f]"
    >
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          eyebrow="Kind Words"
          title="Loved by Our Guests"
        />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-20">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.name} delay={i * 0.1}>
              <figure
                data-testid={`testimonial-${i}`}
                className="h-full bg-[#2d3a1f] border border-[#b89d62]/25 p-9 flex flex-col"
              >
                <Quote className="w-9 h-9 text-[#b89d62]/70" />
                <blockquote className="mt-6 font-serif-display italic text-xl text-[#faf9f6]/90 leading-relaxed flex-1">
                  “{t.quote}”
                </blockquote>
                <figcaption className="mt-8">
                  <div className="w-10 h-px bg-[#b89d62]/50 mb-4" />
                  <p className="font-serif-display text-lg text-[#b89d62]">{t.name}</p>
                  <p className="eyebrow mt-1 !text-[#c9d3ca]">{t.detail}</p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
